import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import Header from "../../layouts/Header"
import BackIcon from "../../components/BackIcon"
import { Box, Typography, Card, CardContent, CardActions, Button, Grid, Chip, CircularProgress } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../components/CustomBackdrop"
import { api } from "../../api"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"

// Íconos
import PlayArrowIcon from "@mui/icons-material/PlayArrow"
import InventoryIcon from "@mui/icons-material/Inventory"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" }, warning: { main: "#ed6c02" } },
})

const BandejaMobileIndex = () => {
  const navigate = useNavigate()

  // No usamos filtros complejos ni paginación pesada en la PDA, traemos los primeros 50 asignados
  const [payload] = useState({ page: 1, perPage: 50, filters: {} })

  const { data: tareasData, isLoading } = useQuery({
    queryKey: ["getTomosAsignadosMobile"],
    queryFn: async () => {
      try {
        const response = await api.post("/TomaFisica/getTomosAsignadosMobile", payload)
        return response?.data?.data || response?.data || []
      } catch (error) {
        console.error("Error al cargar tareas móviles:", error)
        return []
      }
    },
    refetchOnWindowFocus: true, // Importante para refrescar si el operario bloquea la pantalla
  })

  const listaTareas = Array.isArray(tareasData) ? tareasData : []

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-2 p-md-3">
        <BackIcon />

        <Box sx={{ mb: 2, textAlign: "center" }}>
          <Typography variant="h5" color="primary" fontWeight="bold">
            Mis Tomas Físicas
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Seleccione un tomo para iniciar o continuar el conteo.
          </Typography>
        </Box>

        <CustomBackdrop isLoading={isLoading} />

        {/* CONTENEDOR MÓVIL: Evita anchos excesivos en pantallas grandes, ideal para PDA */}
        <Box sx={{ maxWidth: "600px", margin: "0 auto", pb: 10 }}>
          {isLoading ? (
            <Box display="flex" justifyContent="center" mt={5}>
              <CircularProgress />
            </Box>
          ) : listaTareas.length === 0 ? (
            <Box textAlign="center" mt={5} p={3} bgcolor="#f5f7fa" borderRadius={2}>
              <InventoryIcon sx={{ fontSize: 60, color: "gray", mb: 2 }} />
              <Typography variant="h6" color="textSecondary">
                No tienes tareas asignadas
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {listaTareas.map((tarea) => (
                <Grid item xs={12} key={tarea.contnumero}>
                  <Card
                    sx={{ borderRadius: 3, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderLeft: "6px solid #196C87" }}
                  >
                    <CardContent sx={{ pb: 1 }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                        <Typography variant="subtitle2" color="textSecondary">
                          Tomo: <b>{tarea.tomnumero}</b>
                        </Typography>
                        <Chip
                          label={tarea.contstatus === "A" ? "NUEVO" : "EN PROCESO"}
                          color={tarea.contstatus === "A" ? "primary" : "warning"}
                          size="small"
                          sx={{ fontWeight: "bold" }}
                        />
                      </Box>
                      <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.2, mb: 1 }}>
                        {tarea.tomdescripcion}
                      </Typography>
                      <Typography variant="body2">
                        <b>Bodega:</b> {tarea.bodcodigo}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Fecha Asignación: {tarea.contfecha ? normalFormatDate(tarea.contfecha) : ""}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ p: 2, pt: 0 }}>
                      <Button
                        variant="contained"
                        color={tarea.contstatus === "A" ? "primary" : "warning"}
                        fullWidth
                        size="large"
                        startIcon={<PlayArrowIcon />}
                        sx={{ fontWeight: "bold", py: 1.5, borderRadius: 2 }}
                        onClick={() =>
                          navigate("crear", {
                            state: {
                              tomnumero: tarea.tomnumero,
                              contnumero: tarea.contnumero,
                              invcodigo: tarea.invcodigo,
                              bodcodigo: tarea.bodcodigo,
                              tomdescripcion: tarea.tomdescripcion,
                            },
                          })
                        }
                      >
                        {tarea.contstatus === "A" ? "INICIAR CONTEO" : "CONTINUAR CONTEO"}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default BandejaMobileIndex
